import {Helmet} from 'react-helmet';

import {CompoundTitle} from './compound-title';
import {FooterImage} from './footer-image';
import {LeadBoardImage} from './lead-board-image';
import {MainHeader} from './main-header';
// @ts-expect-error
import signupData from './signup';

import styles from './pre-auth-layout-v2.module.css';

export type SignupData = {
    title: string;
    reviewSectionTitle: string;
};

interface Props {
    form: React.ReactNode;
}

export function PreAuthLayoutV2(props: Props) {
    const data: SignupData = signupData;

    return (
        <div className={styles['outer-container']}>
            <div className={styles['inner-container']}>
                <Helmet>
                    <meta name='viewport' content='width=device-width,initial-scale=1' />
                </Helmet>
                <div className={styles['left-content']}>
                    <div className={styles.header}>
                        <MainHeader />
                    </div>
                    <div className={styles.title}>
                        <CompoundTitle title={data.title} />
                    </div>
                    <div className={styles.form}>{props.form}</div>
                    <div className={styles.footer}>
                        <FooterImage />
                    </div>
                </div>
                <div className={styles['right-content']}>
                    <div className={styles['right-top-section']}>
                        <CompoundTitle title={data.title} />
                        <div className={styles['lead-board']}>
                            <LeadBoardImage />
                        </div>
                    </div>
                    <div className={styles.footer}>
                        <FooterImage />
                    </div>
                </div>
            </div>
        </div>
    );
}
